import { render, staticRenderFns } from "./DeviceDetailTag.vue?vue&type=template&id=687f330a&"
import script from "./DeviceDetailTag.vue?vue&type=script&lang=js&"
export * from "./DeviceDetailTag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports